import { GlobalData } from "../../Common/GlobalData";

export class RsLineNewHigh {
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(RsLineNewHigh.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_RSLINE_NEWHIGH,
                }
            },
            height: 915,
            groupable: false,
            pageable: false,
            sortable: true,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '17%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                    attributes: { 'class': 'table-cell grid-cell-left' },
                },
                {
                    field: "close",
                    title: "Closing<br />Price",
                    width: '7%',
                    sortable: false,
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    format: '{0:c2}',
                },
                {
                    field: 'sector',
                    title: 'Sector',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'industryName',
                    title: 'Industry Name',
                    width: '15%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                //{
                //    field: 'relativeStrengthLineNewHigh',
                //    title: 'RS Line<br />New High',
                //    width: '7%',
                //    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                //    attributes: { 'class': 'table-cell grid-cell-center' },
                //    format: '{0:n0}',
                //},
                {
                    field: 'industryGroupRank',
                    title: 'Ind Group<br />Rank',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    format: '{0:n0}',
                },
                {
                    field: 'relativeStrengthRating',
                    title: 'RS<br />Rating',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    format: '{0:n0}',
                },
                {
                    field: 'compositeRating',
                    title: 'Comp<br />Rating',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    format: '{0:n0}',
                },
                {
                    field: 'pattern',
                    title: 'Pattern',
                    width: '11%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'stageA',
                    title: 'Stage<br />A',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'pivotNote1',
                    title: 'PivotNote',
                    width: '17%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
            ]
        });
    }
}
